<template>
  <div class="footer">
    <van-collapse v-model="activeNames"
                  accordion>
      <van-collapse-item name="1"
                         title="关于新奥">
        <div class="footersubmenu">
          <a @click="goToPage('about','#jtjj')">集团简介</a>
          <a @click="goToPage('about','#qywh')">企业文化</a>
          <a @click="goToPage('about','#shzz')">社会责任</a>
          <a @click="goToPage('about','#fzlc')">发展历程</a>
          <a @click="goToPage('about','#ldtd')">领导团队</a>
          <a @click="goToPage('about','#gpxx')">股票信息</a>
        </div>
      </van-collapse-item>
      <van-collapse-item name="2"
                         title="业务布局">
        <div class="footersubmenu">
          <a @click="goToPage('energy')">清洁能源业务</a>
          <a @click="goToPage('life')">品质生活业务</a>
          <a @click="goToPage('intelligent')">产业智能业务</a>
        </div>
      </van-collapse-item>
    </van-collapse>
    <a @click="goToPage('innovate')"
       class="footermenu">创新能力</a>
    <a @click="goToPage('talent')"
       class="footermenu">人才激发</a>
    <a @click="goToPage('news')"
       class="footermenu">新奥动态</a>
    <a @click="goToPage('contactus')"
       class="footermenu">联系我们</a>
    <a @click="goToPage('legal')"
       class="footermenu">法律声明</a>
    <!-- 底部信息 -->
    <div class="footerinfo">
      版权公告 © 2025 新奥集团 版权所有<br />
      <a href="https://beian.miit.gov.cn"
         target="_blank">冀ICP备05013989号-8</a>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=13109802000309"
         target="_blank"><img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png"
             alt="">冀公网安备13109802000309</a>
    </div>
    <!-- 底部信息 -->
  </div>
</template>

<script>
export default {
  name: "Footer",
  data () {
    return {
      activeNames: "0",
    };
  },
  methods: {
    goToPage (url, maodian) {
      console.log(window.location.hash)
      console.log(url)
      let nowUrl = window.location.hash.replace('#/', '')
      if (nowUrl !== url) {
        this.$router.push({ name: url, params: { maodian: maodian } })
      } else {
        this.popmenu = false
        this.pop_about = false
        this.pop_busi = false
        const targetElement = document.querySelector(maodian);
        window.scrollTo({ top: targetElement.offsetTop - 45, behavior: 'smooth' });
      }
    },
  },
  mounted () {
  }
};
</script>
<style>
.footer {
  width: 630px;
  height: auto;
  overflow: hidden;
  padding: 60px;
  background: #f1f2f6;
}
.footer .footermenu {
  width: 630px;
  height: 80px;
  display: block;
  float: left;
  text-align: left;
  font-size: 28px;
  color: #000;
  line-height: 80px;
}
.footerinfo {
  border-top: 1px solid #cbcbcb;
  width: 630px;
  height: auto;
  overflow: hidden;
  background: #f1f2f6;
  font-size: 24px;
  line-height: 50px;
  color: #868686;
  padding-top: 50px;
}
.footerinfo img {
  width: 26px;
  height: 26px;
}
.footerinfo a {
  color: #323233;
  padding: 0 10px;
}
.footer .footersubmenu {
  width: 630px;
  height: auto;
  display: block;
  float: left;
}
.footer .footersubmenu a {
  width: 595px;
  height: 80px;
  display: block;
  float: left;
  color: #323233;
  font-size: 26px;
  line-height: 80px;
  text-align: left;
  padding-left: 35px;
}
/* 底部折叠组件 */
.van-collapse-item {
  width: 630px;
  float: left;
  height: auto;
  overflow: hidden;
}
.van-collapse {
  height: auto;
  overflow: hidden;
  float: left;
}
.van-cell {
  width: 630px;
  height: 80px;
  line-height: 80px;
  background-color: #f1f2f6;
  font-size: 28px;
  padding: 0;
  text-align: left;
  color: #000;
}
.van-collapse-item__content {
  padding: 0;
  height: auto;
  overflow: hidden;
  background: #f1f2f6;
}
</style>